export default{
    namespaced: true,
    state:{
        nuevoCom: '',
    },
    mutations:{
        nuevo(payload){
            this.nuevoCom = payload
        }
    }
}